<template>
	<div
		class="allergy-container d-flex align-items-center"
		v-if="getAllergiesCount(meal, userStore) > 0">
		<img src="../assets/skull.webp" alt="BAD" width="25" />
		<div
			v-text="getAllergies(meal, userStore).join(', ')"
			v-if="showText"></div>
	</div>
</template>

<script setup>
	import { getAllergies, getAllergiesCount } from "../utils/mealLib"
	import { useUserStore } from "@/stores/user"

	const userStore = useUserStore()

	const props = defineProps({
		meal: Object,
		showText: {
			type: Boolean,
			default: true,
		},
	})
	// console.log(getAllergiesCount(props.meal, userStore))
</script>

<style lang="less" scoped>
	.allergy-container {
		background: rgba(0, 0, 0, 0.8);
		padding: 5px;
		max-width: 250px;
		> div {
			font-weight: bolder;
			margin-left: 10px;
			font-size: 20px;
			color: red;
		}
	}
</style>
